import { getRoleName } from 'pages/WellGuardian/WIR/utils';
import { NOT_APPLICABLE } from 'pages/WellGuardian/WIR/wir.constants';
import { WIRTransverseRoles } from 'types/wellGuardian';

import { MULTIPLE_ROLES } from '../userRoleSettingsModal.constants';

export const getUserRole = (roles: WIRTransverseRoles[] | undefined) => {
  if (Number(roles?.length) === 1) {
    return roles && getRoleName(roles[0]);
  } else if (Number(roles?.length) === 2) {
    return getRoleName(
      roles?.find(role => role !== WIRTransverseRoles.READ_ONLY_WIR_USER) as WIRTransverseRoles,
    );
  } else if (Number(roles?.length) === 3) {
    return getRoleName(
      roles?.find(
        role =>
          role !== WIRTransverseRoles.READ_ONLY_WIR_USER && role !== WIRTransverseRoles.WIR_USER,
      ) as WIRTransverseRoles,
    );
  } else if (Number(roles?.length) > 3) {
    return MULTIPLE_ROLES;
  } else {
    return NOT_APPLICABLE;
  }
};
